// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { apiPut, BASE_URL, retrieveToken } from "../../store/api";
import { showModal } from "../modal/modal.actions";
import { UserRoleSaveResponse } from "./types";

import * as userRoleActions from "./userRole.actions";

export function* saveRole(
  action: ReturnType<typeof userRoleActions.saveRoleAsync.request>
) {
  try {
    let errors: ErrorResponse = {
      name: '',
      message: '',
      code: 422,
      status: 422,
      data: []
    };

    if (!action.payload.NAME) {
      errors.data?.push({
        field: "NAME",
        message: "Nama peran wajib diisi"
      })
    }

    if (errors.data && errors.data.length > 0) {
      yield put(userRoleActions.saveRoleAsync.failure(errors));
      return;
    }

    const token: string = yield retrieveToken();
    const url = BASE_URL + 'roles/' + action.payload.ROLE_ID;
    const saveData = {...action.payload};

    saveData.PERMISSIONS = {...saveData.PERMISSION_DETAIL};

    const result: Response = yield call(apiPut, url, token, saveData);

    if (result.status === 200) {
      const parsed: UserRoleSaveResponse = yield call(result.json.bind(result));
      yield put(showModal('Data berhasil disimpan', 'Silahkan tutup dialog ini untuk melanjutkan kegiatan Anda.'));
      yield put(userRoleActions.saveRoleAsync.success(parsed));
      return;
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(userRoleActions.saveRoleAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(showModal('Data gagal disimpan', 'Terjadi kesalahan pada server. Mohon coba kembali dalam beberapa saat.'));
    yield put(userRoleActions.saveRoleAsync.failure(parsed));
  }
}

export default function* userRoleSagaSaveRole() {
  yield takeEvery(userRoleActions.saveRoleAsync.request, saveRole);
}
